import React from 'react';
import { observer } from 'mobx-react';
import RegisterComponent from './Register.component';
import useRegister from './useRegister';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { state, store, lang, handlers } = useRegister(onClose);

    return (
        <>
            <RegisterComponent
                lang={lang.lang}
                loading={store.registerLoading}
                privacyPolicyAccepted={state.privacyPolicyAccepted}
                privacyPolicyError={state.privacyPolicyError}
                email={state.email}
                password={state.password}
                passwordConfirm={state.passwordConfirm}
                emailError={state.emailError}
                passwordError={state.passwordError}
                passwordConfirmError={state.passwordConfirmError}
                registerError={store.registerError}
                serverError={store.serverError}
                onEmailChange={handlers.handleEmailChange}
                onPasswordChange={handlers.handlePasswordChange}
                onPasswordConfirmChange={handlers.handlePasswordConfirmChange}
                onPrivacyPolicyClick={handlers.handlePrivacyPolicyClick}
                onSignUpClick={handlers.handleSignUpClick}
                onInputClick={handlers.handleInputClick}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const RegisterContainer = observer(Container);

export default RegisterContainer;
